// coverUtils.js

/**
 * Derives the 480px desktop cover variant from the original desktop cover URL.
 *
 * Supported formats:
 * - New server format: ...-processed.webp -> ...-processed-480.webp
 * - Fallback: ... .webp -> ...-480.webp
 */
export function deriveCover480UrlFromDesktopCover(coverUrl) {
    const u = String(coverUrl || '').trim();
    if (!u) return null;

    // New server format: ...-processed.webp -> ...-processed-480.webp
    if (/-processed\.webp(\?.*)?$/i.test(u)) {
        return u.replace(/-processed\.webp(\?.*)?$/i, '-processed-480.webp');
    }

    // Fallback: ... .webp -> ...-480.webp
    if (/\.webp(\?.*)?$/i.test(u)) {
        return u.replace(/\.webp(\?.*)?$/i, '-480.webp');
    }

    return null;
}

